import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_685mypxyu2: FaireBrandEntity = {
  token: "b_685mypxyu2",
  type: "brand",
  name: "Fabina",
  avatarUrl:
    "https://cdn.faire.com/fastly/76875e95f27c3a82cf9bcd547c785ec5b2754ce727ba11e6c878ce1826cfd4bc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8f09875ec2bfa96460414b33abe9de4a423e277e7c598a8066eeedc217f91ee4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/76875e95f27c3a82cf9bcd547c785ec5b2754ce727ba11e6c878ce1826cfd4bc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8f09875ec2bfa96460414b33abe9de4a423e277e7c598a8066eeedc217f91ee4.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 1,
  rating: 4.8,
  reviewCount: 162,
  isInsider: true,
  description:
    "Fabina is an environmentally friendly product. \nWe genuinely care about our environment. \nBy using natural fibers and avoiding any poly materials, as well as developing recycled cotton, our ongoing efforts aim to distance ourselves from harmful materials and production.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:13.600Z",
    importedBy: "entity-db-cli",
  },
};
